export function initScrollState({
    root = document.documentElement,
    className = "scrolled",
    threshold = 40,
} = {}) {
    if (!root) return () => { };

    const update = () => {
        root.classList.toggle(className, window.scrollY > threshold);
    };

    // initial + scroll listener
    update();
    window.addEventListener("scroll", update, { passive: true });

    // return cleanup (handy if you ever need it)
    return () => window.removeEventListener("scroll", update);
}
